import { ModularStoreSetupSteps } from "@shared/types/ModularStoreSetupSteps";

const onboarding: any = {
  Welcome: "Welcome to Emerson Ecologics, {{name}}",
  FieldIsRequired: "{{field}} is required",
  FieldCannotHaveWhitespace: "{{field}} cannot begin with whitespace",
  BackToBusinessAddress: "Back to business address",
  stepName: {
    [ModularStoreSetupSteps.ADDRESS_INFORMATION]: "Business Address",
    [ModularStoreSetupSteps.CERTIFICATE]: "Upload your healthcare credentials",
  },
  stepDescription: {
    [ModularStoreSetupSteps.ADDRESS_INFORMATION]:
      "This Address must be the one that your business is registered with.",
    [ModularStoreSetupSteps.CERTIFICATE]:
      "Before you can order products, we <1>review your credentials</1> to ensure all healthcare providers meet Emerson Ecologics professional standards.",
  },
  nextStepName: {
    [ModularStoreSetupSteps.CERTIFICATE]: "upload credentials",
  },
  nextStepButton: "Next: {{ stepName }}",

  HowWeProtectInfo: "How we protect your information",
  HowWeProtectInfoTooltip:
    "Emerson Ecologics is committed to protecting your privacy. All information provided is securely encrypted.",
  Actions: {
    DoLater: "I'll do this later",
    UploadCreds: "Upload credentials",
    NextUploadCreds: "Next: upload credentials",
    CTA: "Complete set up",
  },
  AddressStep: {
    Labels: {
      Address1: "Business Address 1",
      Address2: "Business Address 2",
      StudentAddress1: "Address 1",
      StudentAddress2: "Address 2",
      City: "City",
      State: "State",
      Zipcode: "Zip",
      Phone: "Phone number",
      FieldOfStudy: "Field of study",
      GraduationDate: "Graduation date",
    },
    Errors: {
      PhoneLengthError: "Must be at least 8 digits.",
      Required: "This field is required.",
    },
  },
  Success: {
    LearnMore: "Learn more",
    Explore: "Explore our product catalog",
    Title: "Account setup complete",
    Subtitle:
      "We'll verify your credentials within 24 hours. <1/> In the meantime, you can continue exploring 400+ brands of healthcare's best supplements.",
    Info: {
      Title: "Enhance your in-office dispensing with Fullscript",
      Subtitle: "Sending patients home with supplements in hand is just the first step. ",
      body: "Fullscript can help drive engagement and deliver better outcomes. See how the leading platform for whole person care can complement your in-office dispensing and help you deliver quality care at a greater scale.",
      getAccess: "Get access to Fullscript for free with your Emerson Ecologics account.",
    },
    VideoError: "Your browser does not support the video tag.",
  },
  StepText: "Step {{currentStep}}/{{totalSteps}}",
  uploadError: {
    title: "There was a problem uploading your file",
    message: "Please reload the page and try again or try with a different file",
  },
};

export { onboarding };
